const phishingIcon = { prefix: "fa-kit" as const, iconName: "phished" };
const embeddedVideoIcon = { prefix: "fa-kit" as const, iconName: "embedded-video" };

export const customFontAwesomeIcons = {
  phishing: phishingIcon,
  embeddedVideo: embeddedVideoIcon,
};
